export const WOJEWODZTWA: ReadonlyArray<{ code: string; name: string }> = [
  { code: "DS", name: "Dolnośląskie" },
  { code: "KP", name: "Kujawsko-Pomorskie" },
  { code: "LU", name: "Lubelskie" },
  { code: "LB", name: "Lubuskie" },
  { code: "LD", name: "Łódzkie" },
  { code: "MA", name: "Małopolskie" },
  { code: "MZ", name: "Mazowieckie" },
  { code: "OP", name: "Opolskie" },
  { code: "PK", name: "Podkarpackie" },
  { code: "PD", name: "Podlaskie" },
  { code: "PM", name: "Pomorskie" },
  { code: "SL", name: "Śląskie" },
  { code: "SK", name: "Świętokrzyskie" },
  { code: "WN", name: "Warmińsko-Mazurskie" },
  { code: "WP", name: "Wielkopolskie" },
  { code: "ZP", name: "Zachodniopomorskie" },
] as const;

export const WOJEWODZTWA_CODES = WOJEWODZTWA.map((w) => w.code);
